import { useState } from "react";
import { contact } from '../../../firebase';


export default function Contact() {

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");
    const [loader, setLoader] = useState(false);
    const [msg, setMsg] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoader(true);
        setMsg("");
        contact(name, email, subject, message)
            .then((res) => {
                setMsg("Your message has been sent. Thank you!");
                setLoader(false);
                resetForm();
            })
            .catch((error) => {
                setMsg(error.message);
                setLoader(false);
                resetForm();
            });

    };

    const resetForm = () => {
        setName("");
        setEmail("");
        setSubject("");
        setMessage("");
    }

    return (
        <section id="contact" className="contact">
            <div className="container" data-aos="fade-down">
                <div className="section-title">
                    <h2>Contact Us</h2>
                    <p>Contact us the get started</p>
                </div>
                <div className="row">
                    <div className="col-lg-5 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay={100}>
                        <div className="info">
                            <div className="address">
                                <i className="bi bi-geo-alt" />
                                <h4>Location:</h4>
                                <p>Dumka,Jharkhand</p>
                            </div>
                            <div className="email">
                                <i className="bi bi-envelope" />
                                <h4>Email:</h4>
                                <p>solutionPoint@gmail.com</p>
                            </div>
                            <div className="phone">
                                <i className="bi bi-phone" />
                                <h4>Call:</h4>
                                <p>+91 1111111111</p>
                            </div>
                            <iframe title="google-map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d116382.1961487983!2d87.2554748329501!3d24.27869937413143!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f0b7b4985d6179%3A0x9c3a3b726f103305!2sDumka%2C%20Jharkhand!5e0!3m2!1sen!2sin!4v1641016246953!5m2!1sen!2sin" frameBorder={0} style={{ border: 0, width: '100%', height: 290 }} allowFullScreen />
                        </div>
                    </div>
                    <div className="col-lg-7 mt-5 mt-lg-0 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay={200}>
                        <form className="php-email-form">
                            <div className="row">
                                <div className="form-group col-md-6">
                                    <label htmlFor="name">Your Name</label>
                                    <input type="text" className="form-control" placeholder="Your Name" required
                                        value={name} onChange={(e) => setName(e.target.value)}
                                    />
                                </div>
                                <div className="form-group col-md-6 mt-3 mt-md-0">
                                    <label htmlFor="name">Your Email</label>
                                    <input type="email" className="form-control" name="email" id="email" placeholder="Your Email" required
                                        value={email} onChange={(e) => setEmail(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="form-group mt-3">
                                <label htmlFor="name">Subject</label>
                                <input type="text" className="form-control" name="subject" id="subject" placeholder="Subject" required
                                    value={subject}
                                    onChange={(e) => setSubject(e.target.value)}
                                />
                            </div>
                            <div className="form-group mt-3">
                                <label htmlFor="name">Message</label>
                                <textarea className="form-control" name="message" rows={10} required
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                />
                            </div>
                            <div className="text-center">
                                {loader ? <button type="submit" disabled>Wait</button>
                                    : <button type="submit" onClick={handleSubmit}>Send Message</button>}
                            </div>
                            {msg && <div className="alert alert-success mt-2" role="alert">{msg}</div>}
                        </form>
                    </div>
                </div>
            </div>
        </section>

    );
}